<template>
  <div>
    <!-- Form -->
    <v-container grid-list-md>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <span class="title">{{ formTitle }}</span>
          </v-card-title>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md3 class="pr-4">
                    <!-- Report File Name to Controller Function Name -->
                    <v-text-field
                      label="Controller Function Name"
                      v-model="formSchema.file_name"
                      :rules="[v => !!v || 'Field is required']"
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-text-field
                      label="Controller Short Name"
                      v-model="formSchema.con_short_name"
                      :rules="[v => !!v || 'Controller short name is required']"
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-text-field
                      label="Report Title"
                      v-model="formSchema.report_title"
                      :rules="[v => !!v || 'Field is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-text-field
                      label="Serial Number"
                      v-model="formSchema.serial_num"
                      :rules="[v => !!v || 'Field is required']"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-select
                      label="Module Name"
                      item-text="menu_name"
                      item-value="id"
                      v-model="formSchema.menu_id"
                      :items="MainMenus"
                      :rules="[v => !!v || 'Field is required']"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-select
                      label="Role to Permission"
                      item-text="label"
                      item-value="value"
                      v-model="formSchema.user_role"
                      :items="roleList"
                      :rules="[v => !!v || 'Field is required']"
                      multiple
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md3 sm3>
                    <v-checkbox
                      v-model="formSchema.is_active"
                      label="Active"
                      :value="isActiveVal"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="pr-4">
                    <v-btn
                      class="info"
                      flat
                      @click.native="close({message:'Form Reseted !',status:1})"
                    >
                      <v-icon>refresh</v-icon>Reset
                    </v-btn>
                    <v-btn
                      class="success"
                      flat
                      v-if="userRole.saveButton || userRole.updateButton"
                      @click.native="validateBeforeSubmit"
                    >
                      <v-icon>save</v-icon>
                      {{ buttonTitle }}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-container>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service");

export default {
  props: ["formSchema"],

  data: () => ({
    valid: true,
    isActiveVal: 1,
    roleList: [],
    MainMenus: []
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0
        ? "Edit Report Parameter Master"
        : "Add Report Parameter Master";
    },
    buttonTitle() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    },

    // User Previlization methods
    userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    }
  },

  created() {
    let root = this;
    // Asset Location List
    commonService.getAllData("get_menu_info").then(res => {
      root.MainMenus = res.data;
    });
    commonService.getAllData("get-role-list").then(res => {
      root.roleList = res.roleList;
    });
  },

  methods: {
    validateBeforeSubmit(e) {
      var formSchema = this.formSchema;
      console.log(formSchema);

      var root = this;
      if (root.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService
            .updateFormData(this.formSchema, "report_master")
            .then(res => {
              this.close(res);
            });
        } else {
          commonService
            .insertFormData(this.formSchema, "report_master")
            .then(res => {
              this.close(res);
            });
        }
      }
    },

    close: function(data) {
      if (data.status == 1) {
        this.$refs.form.reset();
        this.formSchema.id = 0;
      }
      this.$emit("emitCloseModal", data);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/report/report_master/report_master_form.vue